import React, {useContext, useEffect, useMemo, useState} from "react";
import {Layout} from "antd";
import styles from "./Save.module.scss";
import {useTranslation} from "react-i18next";
import {checkEmpty, getNameProfile,} from "src/service/util.service";
import {AppContext} from "../../context/App.context";
import useFetch, {CachePolicies} from "use-http";
import {UserAPIEndpoint} from "src/service/user.service";
import {HomeContext, HomeProviderContext} from "../../Home/Home.context";

//@ts-ignore
import _ from "lodash";
import FeedsContent from "../../../components/FeedsContent";
import {useNavigate, useLocation} from "react-router-dom";
import useQuery from "../../../hooks/useQuery";
import {pathRoutes} from "../../../props/util.props";

const { Content } = Layout;

const Post = () => {
  return (
    <HomeProviderContext>
      <MyPostContainer />
    </HomeProviderContext>
  );
};

const pages = {
  save: "save",
  draft: "draft",
};

const tabs = [
  { label: 'Save', key: 'save' },
  { label: 'Draft', key: 'draft'},
];

const MyPostContainer = (props: any) => {
  const query = useQuery();
  const { t } = useTranslation();
  const appCtx: any = useContext(AppContext);
  const location = useLocation()
  const navigate = useNavigate()
  const homeContext: any = useContext(HomeContext);
  const [showModalCreatePost, setShowModalCreatePost] = useState<boolean>(false);
  // const postCtx: any = useContext(PostContext);
  const [page, setPage] = useState(pages.save);


  const callLimit = 15;

  const noDataHeaderText = t("No post available");
  const noSaveDatatext = t("When you save the post It'll appear on this page");

  const noDraftDataText = t("When you draft the post It'll appear on this page");

  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  useEffect(() => {
    const query = new URLSearchParams(location?.search);
    const key = query.get('key');
    if (key) {

    } else {

    }

  }, [location])

  const setDataUser = async () => {
    if (checkEmpty(homeContext.user)) {
      const me = await api.get(UserAPIEndpoint.Me);
      homeContext.setUser(me);
    }
    if (checkEmpty(appCtx.profile)) {
      appCtx.setProfile({
        usernameProfile: homeContext.user?.id,
        username : homeContext.user?.username,
        nameProfile:
        getNameProfile(homeContext.user?.firstname,homeContext.user?.lastname),
        imgUrlProfile: homeContext.user?.imageProfileURL,
      });
    }
  };
  useEffect(() => {
    // setDataUser();
  }, []);

  const sortFeeds = (feeds: any) => {
    feeds?.sort((a: any, b: any) => {
      if (a.createdAt > b.createdAt) return -1;
      if (a.createdAt < b.createdAt) return 1;
    });
  };

  const onCloseModalCreatePost = () => {
    setShowModalCreatePost(false);
  }


  const loadFeeds = async (search: any, limit: any, offset: any) => {
    let filterUrl: any;

    if (page === pages.draft) {
      filterUrl = `&isMyPost=true&status=draft`;
    } else {
      filterUrl = `&isPin=true`;
    }

    const data = await api.get(
      `/api/v1/feeds/?search=${search}&limit=${limit}&offset=${offset}${filterUrl}`
    );
    sortFeeds(data?.feeds);
    console.log("myData", data);
    return data;
  };

  const initFeeds = async () => {
    const data = await loadFeeds("", callLimit, 0);
    console.log("Feeds", data?.feeds);
    homeContext.setFeeds(data);
    checkHasMore(data?.feeds?.length, data?.total);
  };

  const setPreviewCovers = (previewCovers: any) => {
    const covers = new Array();
    for (let index = 0; index < previewCovers.length; index++) {
      let cover = {
        coverLink: previewCovers[index],
      };
      covers.push(cover);
    }
    if (_.isEmpty(homeContext.previewCovers)) {
      homeContext.setPreviewCovers(covers);
      showModal();
    } else {
      homeContext.setPreviewCovers((prevCovers: any) => [
        ...prevCovers,
        ...covers,
      ]);
    }
  };

  const showModal = () => {
    setShowModalCreatePost(true);
  };

  const checkHasMore = (currentTotal: number, total: number) => {
    if (currentTotal + callLimit >= total) homeContext.setHasMorePost(false);
  };

  const fetchNextPost = async () => {
    console.log("loading more...");

    checkHasMore(homeContext.feeds?.feeds?.length, homeContext.feeds?.total);

    if (homeContext.feeds?.feeds?.length < homeContext.feeds?.total) {
      const comingData = await loadFeeds(
        "",
        callLimit,
        homeContext.feeds?.feeds?.length
      );

      homeContext.setFeeds((prev: any) => {
        const newPostsData = {
          feeds: [...prev.feeds, ...comingData.feeds],
          total: prev.total,
        };
        return newPostsData;
      });
    }
  };

  const getActiveStyle = (pageBtn: string) => {
    return pageBtn === page ? styles.pageBtnActive : styles.pageBtnUnActive;
  };

  const handleChangePage = (pageName: string) => {
    setPage(pageName);
  };

  const handleBack = () => {
    homeContext.setFeeds(null);
    homeContext.setCurrentPost(null);
    if (typeof props.setKeyMenu === "function") props.setKeyMenu();
    initFeeds();
  };

  useEffect((): any => {
    let mounted = true;

    if (mounted) {
      initFeeds();
    }

    return () => (mounted = false);
  }, [homeContext.user]);

  useEffect(() => {
    initFeeds();
  }, [page]);

  const params = useMemo(() => {
    const isPin = query.get("isPin");
    const isMyPost = query.get("isMyPost");
    const status = query.get("status");

    let newParams: any = {}

    if (isPin) {
      newParams.isPin = isPin
    }
    if (isMyPost) {
      newParams.isMyPost = isMyPost
    }
    if (status) {
      newParams.status = status
    }

    return newParams;
  }, [query])

  // useEffect(() => {
  //   console.log("newParams", params);
  // }, [params])

  return (
      <Layout>
        <Content>
          <FeedsContent
              style={{
                width: "auto",
                height: "calc(100vh - 50px)",
                paddingTop: "0",
                overflow: "auto",
              }}
              params={params}
              showBoxCreatePost={false}
              headerContent={<div className={styles.pageBtnContainer}>
                <div
                    className={[
                      styles.savePageBtn,
                      (query.get("isPin") === "true") ? styles.pageBtnActive : styles.pageBtnUnActive,
                    ].join(" ")}
                    onClick={() => {
                      navigate(`${pathRoutes.Profile}/save?isPin=true`)
                    }}
                >
                  {t("Save")}
                </div>
                <div
                    className={[
                      styles.draftPageBtn,
                      (query.get("isMyPost") === "true" && query.get("status") === "draft") ? styles.pageBtnActive : styles.pageBtnUnActive,
                    ].join(" ")}
                    onClick={() => {
                      navigate(`${pathRoutes.Profile}/save?isMyPost=true&status=draft`)
                    }}
                >
                  {t("Draft")}
                </div>
              </div>}
          />
        </Content>
      </Layout>

  );
};

export default Post;
